import React, { useEffect } from "react";
import { fetchOrganismsProfiles } from "../../../../../redux/actions/catalog/catalog";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { mapIDescriptionToDropDownOptions } from "../../../../../utils";
import { NumericMultiSelector } from "../../../../common/selectors";
import { IBaseMultipleNumberSelectorProps } from "../IBaseMultipleSelectorProps";
import { MultipleNumberSelectorFilter } from "../multipleSelectorFilter/multipleNumberSelectorFilter";

export const MultipleOrganismProfileSelector: React.FC<IBaseMultipleNumberSelectorProps> = ({ autocomplete, onChange, propertyName, title, selectedKeys }) => {
    const { data, loading } = useAppSelector((store) => store.catalog.organismProfiles);
    const dispatch = useAppDispatch();

    useEffect(() => {
        data === undefined && dispatch(fetchOrganismsProfiles());
    }, [dispatch, data]);

    return autocomplete ? (
        <MultipleNumberSelectorFilter
            selectedKeys={selectedKeys}
            onChange={onChange}
            options={mapIDescriptionToDropDownOptions(data ?? [])}
            label={title}
            propertyName={propertyName}
        />
    ) : (
        <NumericMultiSelector
            onChange={onChange}
            selectedKeys={selectedKeys}
            options={mapIDescriptionToDropDownOptions(data ?? [])}	
            disabled={loading}
            title={title}
            name={propertyName}
        />
    );
};
